//
//
//
//
export default {
  name: 'FibLoader',
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    themeStyle: function themeStyle() {
      return {
        color: this.theme.accentColor
      };
    }
  }
};